const HOUR_MS = 60 * 60 * 1000;
const DAY_MS = 24 * HOUR_MS;
export const isPromptDue = (state, now, config) => {
    if (state.snoozeUntil && state.snoozeUntil > now) {
        return false;
    }
    if (state.lastShownAt && now - state.lastShownAt < config.minIntervalHours * HOUR_MS) {
        return false;
    }
    return true;
};
// Dismissals are permanent — presence of a dismissal record means the drop is hidden for good.
export const isDropDismissed = (dismissedDropIds, dropId) => {
    return Boolean(dismissedDropIds[dropId]);
};
export const pruneExpiredDismissals = (dismissedDropIds, now) => {
    return Object.fromEntries(Object.entries(dismissedDropIds).filter(([, expiresAt]) => expiresAt > now));
};
export const computeSnoozeUntil = (now, hours) => {
    return now + hours * HOUR_MS;
};
export const computeDismissalExpiry = (now, days) => {
    return now + days * DAY_MS;
};
